export function normalizeError(e: unknown) {
    let errorToReport: Error;

    if (e instanceof Error) {
        errorToReport = e;
    } else {
        let message = 'Unknown error';
        let status;
        let response;

        if (typeof e === 'object' && e !== null) {
            if ('error' in e && typeof e.error === 'string') {
                message = e.error;
            } else if ('message' in e && typeof e.message === 'string') {
                message = e.message;
            }

            if ('status' in e) status = e.status;
            if ('response' in e) response = e.response;
        } else if (typeof e === 'string') {
            message = e;
        } else if (typeof e === 'number' || typeof e === 'boolean') {
            message = String(e);
        }

        errorToReport = new Error(message);

        Object.assign(errorToReport, {
            cause: e,
            ...(status !== undefined ? { status } : {}),
            ...(response !== undefined ? { response } : {}),
        });
    }

    return errorToReport;
}
